import { deleteBusinessUnitManagementList } from './deleteBusinessUnitManagementList';
import { sendTenantInvitationRequest } from './sendTenantInvitationRequest';
import { saveOcpFinancial } from './saveOcpFinancial';
import { saveOcpFacilities } from './saveOcpFacilities';
import { saveOcpCertificate } from './saveOcpCertificate';
import { saveOcpStrength } from './saveOcpStrength';
import { saveOcpProfile } from './saveOcpProfile';
import { saveOcpBranch } from './saveOcpBranch';
import { execBusinessUnitContactHeader } from './execBusinessUnitContactHeader';
import { execBusinessUnitContact } from './execBusinessUnitContact';
import { saveBusinessUnitContactAttribute } from './saveBusinessUnitContactAttribute';
import { execConfirmBusinessUnitChangeNotification } from './execConfirmBusinessUnitChangeNotification';
import { execBusinessUnitDocument } from './execBusinessUnitDocument';
import { deleteBusinessUnitDocument } from './deleteBusinessUnitDocument';
import { execStartBusiness } from './execStartBusiness';
import { execStopBusiness } from './execStopBusiness';
import { execRejectSystemManagement } from './execRejectSystemManagement';
import { execUnrejectSystemManagement } from './execUnrejectSystemManagement';
import { createBusinessUnitRelationRequest } from './createBusinessUnitRelationRequest';
import { acceptBusinessUnitRelationReception } from './acceptBusinessUnitRelationReception';
import { rejectBusinessUnitRelationReception } from './rejectBusinessUnitRelationReception';
import { saveOcpSkill } from './saveOcpSkill';
import { updateOcpProfileSystemNotificationSetting } from './updateOcpProfileSystemNotificationSetting';
import { saveBusinessUnitRankReception } from './execSaveBusinessUnitRankReception';
import { deleteBusinessUnitRankReception } from './execDeleteBusinessUnitRankReception';
import { saveOrganizations } from './saveOrganizations';
import { deleteOrganizations } from './deleteOrganizations';
import { saveOrganizationUsers } from './saveOrganizationUsers';
import { deleteBusinessUnitPublicDocument } from './deleteBusinessUnitPublicDocument';
import { saveBusinessUnitPublicDocument } from './saveBusinessUnitPublicDocument';
import { deleteBusinessUnitContact } from './deleteBusinessUnitContact';
import { activateMainContactInBusinessUnitContact } from './activateMainContactInBusinessUnitContact';
import { execUpdateBusinessUnitManagement } from './execUpdateBusinessUnitManagement';
import { execDeleteBusinessUnitFacilities } from './execDeleteBusinessUnitFacilities';
import { saveFacilities } from './saveFacilities';
import { generateBusinessUnitFacilitiesBasic } from './generateBusinessUnitFacilitiesBasic';
import { generateBusinessUnitFacilitiesSkills } from './generateBusinessUnitFacilitiesSkills';
import { saveOcpIntroduction } from './saveOcpIntroduction';
import { publishOcpIntroduction } from './publishOcpIntroduction';
import { generateBusinessUnitIntroduction } from './generateBusinessUnitIntroduction';

// actionName と function のマッピング
export const companyCallMap = {
  saveOrganizations: saveOrganizations,
  deleteOrganizations: deleteOrganizations,
  saveOrganizationUsers: saveOrganizationUsers,
  updateOcpProfileSystemNotificationSetting:
    updateOcpProfileSystemNotificationSetting,
  saveOcpFinancial: saveOcpFinancial,
  saveOcpFacilities: saveOcpFacilities,
  saveOcpCertificate: saveOcpCertificate,
  saveOcpStrength: saveOcpStrength,
  deleteBusinessUnitManagementList: deleteBusinessUnitManagementList,
  sendTenantInvitation: sendTenantInvitationRequest,
  saveOcpProfile: saveOcpProfile,
  saveOcpBranch: saveOcpBranch,
  execBusinessUnitContactHeader: execBusinessUnitContactHeader,
  execBusinessUnitContact: execBusinessUnitContact,
  saveBusinessUnitContactAttribute: saveBusinessUnitContactAttribute,
  execConfirmBusinessUnitChangeNotification:
    execConfirmBusinessUnitChangeNotification,
  execUpdateBusinessUnitManagement: execUpdateBusinessUnitManagement,
  execBusinessUnitDocument: execBusinessUnitDocument,
  deleteBusinessUnitDocument: deleteBusinessUnitDocument,
  execStartBusiness: execStartBusiness,
  execStopBusiness: execStopBusiness,
  execRejectSystemManagement: execRejectSystemManagement,
  execUnrejectSystemManagement: execUnrejectSystemManagement,
  createBusinessUnitRelationRequest: createBusinessUnitRelationRequest,
  acceptBusinessUnitRelationReception: acceptBusinessUnitRelationReception,
  rejectBusinessUnitRelationReception: rejectBusinessUnitRelationReception,
  saveOcpSkill: saveOcpSkill,
  saveBusinessUnitRankReception: saveBusinessUnitRankReception,
  deleteBusinessUnitRankReception: deleteBusinessUnitRankReception,
  deleteBusinessUnitPublicDocument: deleteBusinessUnitPublicDocument,
  saveBusinessUnitPublicDocument: saveBusinessUnitPublicDocument,
  deleteBusinessUnitContact: deleteBusinessUnitContact,
  activateMainContactInBusinessUnitContact:
    activateMainContactInBusinessUnitContact,
  deleteBusinessUnitFacilities: execDeleteBusinessUnitFacilities,
  saveFacilities: saveFacilities,
  generateBusinessUnitFacilitiesBasic: generateBusinessUnitFacilitiesBasic,
  generateBusinessUnitFacilitiesSkills: generateBusinessUnitFacilitiesSkills,
  saveOcpIntroduction: saveOcpIntroduction,
  publishOcpIntroduction: publishOcpIntroduction,
  generateBusinessUnitIntroduction: generateBusinessUnitIntroduction,
};
